module.exports = __webpack_public_path__ + "img/20210823_123212.6208373c.jpg";